import makeSlice from '@web/slices/result/sliceMaker'

const resultSlice = makeSlice()

export default resultSlice.reducer
export const actions = resultSlice.actions
